import * as React from "react";

interface GenFilterGroupProps {
  title: string;
  children: React.ReactNode;
}

export default function GenFilterGroup(
  {
    title,
    children,
  }: GenFilterGroupProps,
) {
  return (
    <div className="gen-list-filter-group">
      <h4>{title}</h4>
      <div className="gen-list-filter-group-filters">
        {children}
      </div>
    </div>
  );
}
